/**
 * Calculates the remaining minutes until a scheduled enablement time
 * @param isoTimestamp - ISO 8601 timestamp string of when enablement is scheduled
 * @returns Number of minutes remaining, or null if timestamp is invalid or in the past
 */
export function calculateRemainingMinutes(isoTimestamp: string | undefined): number | null {
  try {
    if (!isoTimestamp) {
      return null;
    }

    const timestampMs = new Date(isoTimestamp).getTime();

    // Check if the date is invalid (NaN)
    if (isNaN(timestampMs)) {
      return null;
    }

    const diffMs = timestampMs - Date.now();

    if (diffMs <= 0) {
      return null;
    }

    return Math.ceil(diffMs / (1000 * 60));
  } catch {
    return null;
  }
}
